import { RootState, SetState } from '@/store/useStore.ts';
import { GameWindowSlice } from './types';
import type { CasinoBalance } from '@/unified-modules/wallet/helpers/normalize-balance';

const defaultGameWindowState = {
  spinInProgress: false,
  gameSwitchInProgress: false,
  skipNextGlsReset: false,
  spinEndCount: 0,
  gameWindowOpen: false,
  audioEnabled: true,
  balance: null as number | null,
  balanceDetails: null as CasinoBalance | null,
  loadingGetBalance: false,
  errorGetBalance: false,
};

export const gameWindowSlice = ({
  set,
}: SetState<RootState>): GameWindowSlice => ({
  gameWindowContext: { ...defaultGameWindowState },
  setGameWindowContext: (newState: Partial<typeof defaultGameWindowState>) =>
    set(
      (state: RootState) => ({
        ...state,
        gameWindowContext: { ...state.gameWindowContext, ...newState },
      }),
      false,
      'gameWindow/setGameWindowContext',
    ),
  resetGameWindowContext: () =>
    set(
      () => ({ gameWindowContext: { ...defaultGameWindowState } }),
      false,
      'gameWindow/resetGameWindowContext',
    ),
});
